const translations = {
    noLabel: 'No',
    yesLabel: 'Yes'
};

export default translations;
